const cards = [
    {
      id: 1,
      title: "PDF to JPG",
      description: "Convert your PDF files into high-quality JPG images, ideal for presentations, sharing, or viewing on any device.",
    },
    {
      id: 2,
      title: "JPG to PDF",
      description: "Easily combine or convert multiple JPG images into a single PDF file for streamlined document sharing.",
    },
    {
      id: 3,
      title: "Compress PDF",
      description: "Reduce the file size of your PDFs without compromising on quality, making them easier to share or store.",
    },
    {
      id: 4,
      title: "Merge PDFs",
      description: "Combine multiple PDF files into one cohesive document for better organization and accessibility.",
    },
    {
      id: 5,
      title: "Split PDF",
      description: "Extract specific pages or split a large PDF into smaller files for easier management.",
    },
    {
      id: 6,
      title: "Rotate PDF",
      description: "Correct the orientation of PDF pages by rotating them to your desired angle.",
    },
    {
      id: 7,
      title: "Unlock PDF",
      description: "Remove password protection from secured PDF files to access and edit them freely.",
    },
    {
      id: 8,
      title: "Protect PDF",
      description: "Secure your PDFs by adding password protection and encryption to safeguard sensitive information.",
    },
  ];
  
  export default cards;
  